import { isApiErrorCode, type ApiErrorType } from '@carrefour-gcs/shared';

function isApiError(error: unknown): error is { apiErrorCode: ApiErrorType } {
  return (
    error !== null &&
    typeof error === 'object' &&
    'apiErrorCode' in error &&
    isApiErrorCode((error as { apiErrorCode: unknown }).apiErrorCode)
  );
}

export function isApiErrorOfType(error: unknown, apiErrorCode: ApiErrorType) {
  if (isApiError(error)) {
    return error.apiErrorCode === apiErrorCode;
  }

  return false;
}
